import React from 'react';
import { Torneio } from '../services/torneioService';

interface TournamentShortcutsProps {
  torneio: Torneio;
  onInscreva: () => void;
}

const TournamentShortcuts: React.FC<TournamentShortcutsProps> = ({
  torneio,
  onInscreva,
}) => {
  const categoriasCount = torneio.categoriasTorneio?.length ?? 0;
  const inscritosCount = torneio.totalInscricoes ?? 0;

  return (
    <div className="col-xl-3 mb-3 mb-xl-0">
      <div className="d-flex flex-column gap-3">
        {/* Atalho Inscreva-se */}
        <div
          className="card border-0 bg-grey cursor-pointer"
          onClick={onInscreva}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onInscreva();
            }
          }}
        >
          <div className="card-body d-flex align-items-center">
            <i className="bi bi-pencil-square text-primary me-3" style={{ fontSize: '1.5rem' }}></i>
            <div>
              <h6 className="fw-700 text-grey-900 mb-0">Inscreva-se</h6>
              <span className="font-xssss text-grey-500">{categoriasCount} categorias</span>
            </div>
          </div>
        </div>

        {/* Atalho Jogadores */}
        <div className="card border-0 bg-grey">
          <div className="card-body d-flex align-items-center">
            <i className="bi bi-people text-primary me-3" style={{ fontSize: '1.5rem' }}></i>
            <div>
              <h6 className="fw-700 text-grey-900 mb-0">Jogadores</h6>
              <span className="font-xssss text-grey-500">{inscritosCount} inscritos</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentShortcuts;
